var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81201 12.5557L3.35205 15.148L5.94433 14.688L6.38236 14.9008C7.17162 15.2842 8.05849 15.5 9 15.5C12.3137 15.5 15 12.8137 15 9.5C15 6.18629 12.3137 3.5 9 3.5C5.68629 3.5 3 6.18629 3 9.5C3 10.4415 3.21579 11.3284 3.59922 12.1176L3.81201 12.5557ZM1.5 17L2.25 12.7731C1.76951 11.784 1.5 10.6735 1.5 9.5C1.5 5.35786 4.85786 2 9 2C13.1421 2 16.5 5.35786 16.5 9.5C16.5 13.6421 13.1421 17 9 17C7.82652 17 6.71598 16.7305 5.72691 16.25L1.5 17Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72013 10.4748C5.96831 9.33258 5.91203 7.99647 6.07525 7.11365L7.55026 7.38635C7.43615 8.00353 7.49081 8.91742 7.97309 9.65016C8.42328 10.3341 9.33879 11 11.25 11V12.5C8.94583 12.5 7.50405 11.6659 6.72013 10.4748Z",
    fill: "#303030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.875C8.25 7.49632 7.74632 8 7.125 8C6.50368 8 6 7.49632 6 6.875C6 6.25368 6.50368 5.75 7.125 5.75C7.74632 5.75 8.25 6.25368 8.25 6.875Z",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.375C12.75 11.9963 12.2463 12.5 11.625 12.5C11.0037 12.5 10.5 11.9963 10.5 11.375C10.5 10.7537 11.0037 10.25 11.625 10.25C12.2463 10.25 12.75 10.7537 12.75 11.375Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.2a23f8e38077906a5e126cbf972d41f7.svg";
export { ForwardRef as ReactComponent };